import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { KPI, KPIRequest, KPIResponse } from './types'
import { format, subMonths } from 'date-fns'

export const kpiListMounted = createEvent<KPIRequest>()

export const getKPI = fx<KPIRequest, KPIResponse>({
  method: 'GET',
  url: `/user/fin_kpi/summary-report`,
})

export const $kpiList = restore<KPI[]>(
  getKPI.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfKPI = restore(
  getKPI.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: kpiListMounted,
  fn: ({ limit, page, userIds, periodName }) => {
    const today = new Date()
    const lastMonth = subMonths(today, 1)
    const formattedLastMonth = format(lastMonth, 'yyyy-MM')

    let query = {
      limit,
      page,
      where: JSON.stringify({
        periodName: periodName ? periodName : formattedLastMonth,
        user_ids: userIds,
      }),
    }

    return {
      query,
    }
  },
  target: getKPI,
})
